export function getPublicAppEntry({
  isAuthenticated,
  pathname,
}: {
  isAuthenticated: boolean;
  pathname?: string | null;
}) {
  if (isAuthenticated) {
    return {
      href: "/studio",
      label: "Open app",
      description: "Open your private workspace",
    };
  }

  if (pathname?.startsWith("/login")) {
    return {
      href: "/register",
      label: "Create account",
      description: "Create a new account",
    };
  }

  return {
    href: "/login",
    label: "Log in",
    description: "Log into your account",
  };
}
